
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4pSml", function(module, exports) {

$parcel$export(module.exports, "ADFStreamer", () => $c660dc6389f481da$export$7e740171e70a13ac);
class $c660dc6389f481da$export$7e740171e70a13ac {
    processChunk(chunk) {
        this.jsonCloser.append(chunk);
        const [hasChanged, partialJson, stack, openSquareBracketsFor] = this.jsonCloser.parse();
        if (!partialJson || !hasChanged) return this.createCopyOfDoc(this.lastDoc);
        const completeADFJson = hasChanged ? this.parsePartialADFJson(partialJson) : this.lastDoc;
        this.lastStreamCompleteNodePath = this.getCompleteNodePath(partialJson, openSquareBracketsFor, stack);
        return this.createCopyOfDoc(completeADFJson);
    }
    getLastDoc() {
        return this.createCopyOfDoc(this.lastDoc);
    }
    createCopyOfDoc(doc) {
        /**
     * Some older browsers like chrome 97 doesn't support structuredClone.
     * So using JSON.parse(JSON.stringify()) as a fallback.
     */ if (typeof window !== 'undefined' && typeof window.structuredClone === 'function') return structuredClone(doc);
        else return JSON.parse(JSON.stringify(doc));
    }
    parsePartialADFJson(partialJson) {
        /**
     * No need to wait till we get "type: doc" in the JSON.
     * First node type will always be schema.topNodeType, and can start repairing
     * 	the JSON as soon as there is content in it.
     */ try {
            this.lastDoc = this.repairNode({
                partialNodeJson: partialJson,
                // Top node is always at 0th Position.
                treeBranch: [
                    0
                ],
                partiallyRepairedNode: this.lastDoc,
                isTopNode: true
            }).toJSON();
        } catch (e) {
            //TODO: EDITOR-783 - Fire analytic event to track this error
            // eslint-disable-next-line no-console
            console.error('Failed to repair partial JSON', e);
        }
        return this.lastDoc;
    }
    repairNode({ partialNodeJson: partialNodeJson, treeBranch: treeBranch, partiallyRepairedNode: partiallyRepairedNode, parentNodeType: parentNodeType, isTopNode: isTopNode }) {
        /**
     * If type is still not available, and, node has been previsously repaired,
     * 	then just use type of the repaired node.
     * And if node hasn't been repaired, then use default type based on parent node type.
     */ const type = partialNodeJson.type && this.schema.nodes[partialNodeJson.type] || (isTopNode ? this.schema.topNodeType : partiallyRepairedNode?.type && this.schema.nodes[partiallyRepairedNode.type] || parentNodeType?.contentMatch.defaultType);
        if (!type) //TODO: EDITOR-783 - Fire analytic event to track this error.
        throw new Error('Failed to repair node, type not found');
        const maybeMarks = partialNodeJson.marks ? partialNodeJson.marks.map((mark)=>this.repairMark(mark))// Type guard isn't necessary in newer versions of TypeScript
        .filter((mark)=>mark !== null) : [];
        if (type.name === 'text') /**
       * Empty text node is not allowed in prosemirror.
       * Checkout: https://prosemirror.net/docs/ref/#model.Schema.text
       * That's why when text is not available, we are using space as default.
       */ return this.schema.text(partialNodeJson.text ? partialNodeJson.text : ' ', maybeMarks);
        const maybeContent = partialNodeJson.content ? this.repairContent({
            repairedContent: partiallyRepairedNode?.content || [],
            newContent: partialNodeJson.content,
            treeBranch: treeBranch,
            parentNodeType: type
        }).map((node)=>this.schema.nodeFromJSON(node)) : null;
        const node = type.createAndFill(partialNodeJson.attrs, maybeContent, maybeMarks);
        if (!node) //TODO: EDITOR-783 - Fire analytic event to track this error
        throw new Error('Failed to repair node');
        return node;
    }
    repairContent({ repairedContent: repairedContent, newContent: newContent, parentNodeType: parentNodeType, treeBranch: treeBranch }) {
        const repairedContentLength = repairedContent.length;
        let previouslyRepairedNodes = [];
        let completelyRepairedNode;
        if (repairedContentLength > 0 && newContent.length > 0) {
            /**
       * Complete ADF JSON for these nodes has been received.
       * They have been fully reparied.
       */ previouslyRepairedNodes = repairedContent.slice(0, repairedContentLength - 1);
            const mayBePartiallyRepairedNode = repairedContent[repairedContentLength - 1];
            const partialNodeTreeBranch = [
                ...treeBranch,
                repairedContentLength - 1
            ];
            if (mayBePartiallyRepairedNode) {
                if (this.isStreamingOfNodeComplete(partialNodeTreeBranch)) completelyRepairedNode = mayBePartiallyRepairedNode;
                else completelyRepairedNode = this.repairNode({
                    partialNodeJson: newContent[repairedContentLength - 1],
                    parentNodeType: parentNodeType,
                    treeBranch: partialNodeTreeBranch,
                    partiallyRepairedNode: mayBePartiallyRepairedNode
                }).toJSON();
            }
        }
        /**
     * Lastest stream can complete previous node and also add new nodes.
     * New nodes are not repaired yet, so don't have partiallyRepairedNode
     */ const newRepairedContentNodes = newContent.slice(repairedContentLength).map((node, index)=>{
            return this.repairNode({
                partialNodeJson: node,
                treeBranch: [
                    ...treeBranch,
                    repairedContentLength + index
                ],
                parentNodeType: parentNodeType
            }).toJSON();
        });
        // completelyRepairedNode will be undefined when only one node is in content, so filtering it.
        return [
            ...previouslyRepairedNodes,
            completelyRepairedNode,
            ...newRepairedContentNodes
        ].filter((node)=>!!node);
    }
    isStreamingOfNodeComplete(treeBranch) {
        // Streaming is just started and no node has been completed yet.
        if (this.lastStreamCompleteNodePath.length === 0) return false;
        /**
     * If node is in left side of last complete tree branch then it is repaired in last stream.
     * And if it is in right side then it is not repaired yet.
     */ for(let i = 0; i < treeBranch.length; i++){
            if (treeBranch[i] < this.lastStreamCompleteNodePath[i]) return true;
            else if (treeBranch[i] > this.lastStreamCompleteNodePath[i]) return false;
        }
        /**
     * If it reaches to this point then;
     * - current node is is in last complete tree branch, but that it's one of the parent node is still incomplete.
     * In this case, treeBranch length is greater than last complete node path length.
     * And length of both branch is same then it is the same node which was completed in last stream.
     */ return treeBranch.length >= this.lastStreamCompleteNodePath.length;
    }
    getCompleteNodePath(partialJson, openSquareBracketsFor, stack) {
        const numberOfOpenCurlyBrackets = stack.filter((bracket)=>bracket === '{').length;
        const numberOfOpenContentBrackets = openSquareBracketsFor.filter((bracketFor)=>bracketFor === 'content').length;
        /**
     * If there are no open content square brackets then it means that
     * 	- either last received node is complete, or
     *  - doc node content isn't received yet.
     */ if (numberOfOpenContentBrackets === 0) return [];
        const currentRightMostTreeBranch = this.getRightMostTreeBranch(partialJson);
        /**
     * Ideally this should never happen, but just in case if it happens then
     * 	then return empty array so whole new json will be reparied instead of
     *  throwing error becuase this is for optimization, new json can stil be
     *  valid and can be reparied.
     */ if (numberOfOpenContentBrackets > currentRightMostTreeBranch.length) //TODO: EDITOR-783 - Fire analytic event to track this case.
        return [];
        /**
     * Same open content square brackets as length of right most tree branch means, last received node is incomplete.
     * So complete branch is just one position left to current right most tree branch.
     */ if (numberOfOpenContentBrackets === currentRightMostTreeBranch.length) {
            for(let i = currentRightMostTreeBranch.length - 1; i >= 0; i--){
                if (currentRightMostTreeBranch[i] > 0) {
                    currentRightMostTreeBranch[i] -= 1;
                    break;
                }
                currentRightMostTreeBranch.pop();
            }
            return currentRightMostTreeBranch;
        }
        /**
     * When right most branch length is just one more than number of open content square brackets,
     * 	then it means that last node having content is incomplete and
     * 	one or more children of that node may be complete.
     */ if (currentRightMostTreeBranch.length === numberOfOpenContentBrackets + 1) {
            /**
       * If number of open curly brackets is same as number of open content square brackets
       *  then it means all children of last open content node are complete.
       * So current right most tree branch is complete node path.
       */ if (numberOfOpenCurlyBrackets === numberOfOpenContentBrackets) return currentRightMostTreeBranch;
            else if (currentRightMostTreeBranch[currentRightMostTreeBranch.length - 1] > 0) {
                /**
         * If it come here then it means;
         * - open curly brackets are more than open content square brackets
         * - last open content node has more than one children and
         * 	last child is incomplete.
         * So just decrement last child index of current right most tree branch
         * 	to get complete node path.
         */ currentRightMostTreeBranch[currentRightMostTreeBranch.length - 1] -= 1;
                return currentRightMostTreeBranch;
            } else {
                /**
         * If it come here then it means;
         * - open curly brackets are more than open content square brackets
         * - last open content node has only one child which is incomplete.
         * So complete branch is just one position left to current right most tree branch
         */ for(let i = currentRightMostTreeBranch.length - 1; i >= 0; i--){
                    if (currentRightMostTreeBranch[i] > 0) {
                        currentRightMostTreeBranch[i] -= 1;
                        break;
                    }
                    currentRightMostTreeBranch.pop();
                }
                return currentRightMostTreeBranch;
            }
        }
        /**
     * Number of open content square brackets means that, that many nodes from top are incomplete.
     * So last complete node will be last content node of last incomplete node (whose content square bracket is still open).
     */ return currentRightMostTreeBranch.slice(0, numberOfOpenContentBrackets + 1);
    }
    getRightMostTreeBranch(partialJson) {
        // Top node is always at 0th Position.
        const branch = [
            0
        ];
        function setIncompleteTreeBranchForNode(node) {
            if (node.content && Array.isArray(node.content) && node.content.length > 0) {
                branch.push(node.content.length - 1);
                setIncompleteTreeBranchForNode(node.content[node.content.length - 1]);
            }
        }
        setIncompleteTreeBranchForNode(partialJson);
        return branch;
    }
    repairMark(json) {
        if (json.type) {
            const type = this.schema.marks[json.type];
            if (!type) throw new Error('Failed to repair mark');
            return type.create(json.attrs);
        }
        return null;
    }
    constructor(schema, jsonCloser){
        this.jsonCloser = void 0;
        this.schema = void 0;
        this.lastDoc = void 0;
        this.lastStreamCompleteNodePath = [];
        this.jsonCloser = jsonCloser;
        this.schema = schema;
        const defaultDoc = schema.topNodeType.createAndFill()?.toJSON();
        this.lastDoc = {
            ...defaultDoc,
            version: 1
        };
    }
}

});

parcelRegister("2WyI4", function(module, exports) {

$parcel$export(module.exports, "JsonCloser", () => $2e365478dd4fa038$export$779cb430520c124b);
/*
 * MIT License
 *
 * Copyright (c) 2023 Yanael Barbier
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ class $2e365478dd4fa038$export$779cb430520c124b {
    append(chunk) {
        for (const char of chunk){
            this.buffer += char;
            switch(char){
                case '{':
                    if (this.stack[this.stack.length - 1] === ':') this.stack.pop();
                    this.stack.push(char);
                    this.closedObject = false;
                    break;
                case '}':
                    if (this.stack[this.stack.length - 1] === '{') this.stack.pop();
                    this.closedObject = true;
                    this.objectKeyComplete = true;
                    break;
                case '[':
                    if (this.stack[this.stack.length - 1] === ':') this.stack.pop();
                    this.stack.push(char);
                    this.closedArray = false;
                    this.openSquareBracketsFor.push(this.isOpenSquareBracketForContent() ? 'content' : 'other');
                    break;
                case ']':
                    if (this.stack[this.stack.length - 1] === '[') this.stack.pop();
                    this.openSquareBracketsFor.pop();
                    break;
                case '"':
                    if (this.stack[this.stack.length - 1] === ':') this.stack.pop();
                    if (this.stack[this.stack.length - 1] === '"') this.stack.pop();
                    else this.stack.push(char);
                    const secondLastCharter = this.buffer[this.buffer.length - 2];
                    if (secondLastCharter === '{' || secondLastCharter === ',') this.objectKeyComplete = false;
                    break;
                case ':':
                    this.objectKeyComplete = true;
                    if (this.buffer[this.buffer.length - 2] === '"') this.stack.push(char);
                    break;
                default:
                    /**
           * Don't remove colon from stack if char is space, otherwise it will be invlaid JSON.
           */ if (this.stack[this.stack.length - 1] === ':' && char !== ' ') this.stack.pop();
                    break;
            }
        }
    }
    closeJson() {
        let closeBuffer = this.buffer.trim();
        for (const char of [
            ...this.stack
        ].reverse())switch(char){
            case '{':
                if (closeBuffer[closeBuffer.length - 1] === ',') closeBuffer = closeBuffer.slice(0, -1);
                else if (closeBuffer[closeBuffer.length - 1] === '{') this.objectKeyComplete = true;
                else if (!this.objectKeyComplete) {
                    this.objectKeyComplete = true;
                    closeBuffer += ':""';
                }
                closeBuffer += '}';
                break;
            case '[':
                if (closeBuffer[closeBuffer.length - 1] === ',') closeBuffer = closeBuffer.slice(0, -1);
                closeBuffer += ']';
                break;
            case '"':
                if (closeBuffer[closeBuffer.length - 1] === '"' && closeBuffer[closeBuffer.length - 2] === '{') closeBuffer = closeBuffer.slice(0, -1);
                else closeBuffer += '"';
                break;
            case ':':
                /**
           * Valid JSON values are string, number, boolean, object, array or null.
           * object, array, string and number value is already handled.
           *
           * So if last character is "t" for true, "f" for false or "n" for null
           *  then it can be still valid JSON value. When next stream arrives, it can
           * 	complete boolean or null value.
           *
           * Currently we have not handled this case as ADF JSON don't have boolean or null values.
           */ closeBuffer += '""';
                break;
            default:
                break;
        }
        return closeBuffer;
    }
    parse() {
        try {
            const closedJson = this.closeJson();
            if (closedJson === '') return closedJson;
            const jsonRes = JSON.parse(closedJson);
            const size = JSON.stringify(jsonRes).length;
            let hasChanged = false;
            if (size > this.prevSize) {
                this.prevSize = size;
                hasChanged = true;
            } else if (this.closedObject !== this.closedArray) {
                // If the object have been closed consider it as a change
                // If the array have been close the object have been closed too
                // No need to consider it as a change
                // This is to avoid processing twice the same completion
                hasChanged = this.closedObject;
                this.closedObject = false;
            }
            return [
                hasChanged,
                jsonRes,
                this.stack,
                this.openSquareBracketsFor
            ];
        } catch (error) {
            //TODO: EDITOR-783 - Throw analytic event to capture this error
            return [
                false,
                null,
                this.stack,
                this.openSquareBracketsFor
            ];
        }
    }
    isOpenSquareBracketForContent() {
        let startDoubleQuoteIndex = -1;
        let endDoubleQuoteIndex = -1;
        let isSquareBracketForValue = false;
        for(let i = this.buffer.length - 1; i >= 0; i--){
            const char = this.buffer[i];
            /**
       * Color has to be preceded by square bracket for it to
       * 	be considered as a value
       */ if (char === ':') isSquareBracketForValue = true;
            if (isSquareBracketForValue && char === '"') {
                if (endDoubleQuoteIndex === -1) endDoubleQuoteIndex = i;
                else {
                    startDoubleQuoteIndex = i;
                    break;
                }
            }
        }
        return this.buffer.slice(startDoubleQuoteIndex + 1, endDoubleQuoteIndex) === 'content';
    }
    reset() {
        this.buffer = '';
        this.stack = [];
        this.prevSize = 0;
        this.closedObject = false;
        this.closedArray = false;
        this.openSquareBracketsFor = [];
        this.objectKeyComplete = true;
    }
    constructor(){
        this.buffer = '';
        this.stack = [];
        this.objectKeyComplete = true;
        this.openSquareBracketsFor = [];
        this.prevSize = 0;
        this.closedObject = false;
        this.closedArray = false;
    }
}

});


//# sourceMappingURL=FullPageEditorComponent.969b5f61.js.map
